import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

// Same proportions as the audio player's slider (4px rail, round white thumb).
const RAIL_HEIGHT = 8;
const THUMB_SIZE = 12;

export const StyledProgressSlider = styled.div`
  position: relative;
  width: 100%;
  height: ${RAIL_HEIGHT}px;
  border-radius: 999px;
  background: ${COLOR.secondary[80]};
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  /* The thumb overflows the rail by half its size; keep the whole strip above
     the editor sitting on top of the dock so it is never painted over. */
  z-index: 1;
  touch-action: none;
  user-select: none;
`;

/* Both moving parts are driven by `transform` only — the position is rewritten
   every animation frame while playing (see the component), and a transform
   costs no layout, unlike a width/left in percent. */
export const StyledFill = styled.div`
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: ${COLOR.yellow.default};
  transform: scaleX(0);
  transform-origin: left center;
  pointer-events: none;
  will-change: transform;
`;

// Full-rail-width anchor: translating it by N% moves it N% of the RAIL, which is
// what the thumb needs (a percent translate on the thumb itself would be a
// percent of the thumb).
export const StyledThumbAnchor = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 0;
  pointer-events: none;
  will-change: transform;
`;

export const StyledThumb = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${THUMB_SIZE}px;
  height: ${THUMB_SIZE}px;
  /* Centred on the anchor without a transform of its own, so the anchor's
     transform stays the single thing that moves. */
  margin: ${-THUMB_SIZE / 2}px 0 0 ${-THUMB_SIZE / 2}px;
  border: 1px solid ${COLOR.yellow.default};
  border-radius: 50%;
  background: ${COLOR.white};
`;
